<template>
<div id="login">
    <el-main>
        <el-row type="flex" justify="center">
            <el-col :xl="8" :lg="8" :md="8" :xs="8" :sm="8">
                &nbsp;
            </el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="8" :xs="8">
                <h1 style="color: #fff;">SOFNON</h1>
            </el-col>
            <el-col :xl="8" :lg="8" :md="8" :xs="8" :sm="8">
                &nbsp;
            </el-col>

        </el-row>
        <el-form ref="loginForm" :model="loginForm" label-width="80px">
            <el-row type="flex" justify="center">
                <el-col :xl="8" :lg="8" :md="8" :xs="4" :sm="4"></el-col>
                <el-col :xl="8" :lg="8" :md="8" :sm="16" :xs="16">
                    <el-form-item label="帳號:" label-width="80px">
                        <el-input v-model="loginForm.user_id"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xl="8" :lg="8" :md="8" :xs="4" :sm="4"></el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :xl="8" :lg="8" :md="8" :xs="4" :sm="4"></el-col>
                <el-col :xl="8" :lg="8" :md="8" :sm="16" :xs="16">
                    <el-form-item label="密碼:" label-width="80px">
                        <el-input v-model="loginForm.password" type="password"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xl="8" :lg="8" :md="8" :xs="4" :sm="4"></el-col>
            </el-row>
            <el-row type="flex" justify="center">
                <el-col :xl="8" :lg="8" :md="8" :sm="4" :xs="4"></el-col>
                <el-col :xl="8" :lg="8" :md="8" :sm="16" :xs="16" :push="4">
                    <el-button type="primary" @click="login">登入</el-button>
                </el-col>
                <el-col :lg="8" :md="8" :sm="4" :xs="4"></el-col>
            </el-row>

        </el-form>
    </el-main>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex'
export default {
    name: 'Login',
    data() {
        return {
            loginForm: {
                user_id: '',
                password: ''
            },
            users: {}
        }
    },
    computed: mapGetters(["getLoginError", "getLoginMsg"]),
    methods: {
        async login() {
            const data = await {
                user_id: this.loginForm.user_id,
                password: this.loginForm.password
            }
            await this.$store.dispatch('login', data)
            if (this.getLoginError == true) {
                this.$notify({
                    title: '失敗',
                    message: this.getLoginMsg,
                    type: 'error',
                    duration: '4500',
                    position: 'top-right'
                })
            } else {
                this.$emit('login')
                this.$notify({
                    title: '成功',
                    message: '登入成功',
                    type: 'success',
                    duration: '4500',
                    position: 'top-right'
                });

            }

        }
    },
}
</script>

<style lang="scss">
#login {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    background: #007991;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #78ffd6, #007991);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #78ffd6, #007991);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    h1 {
        font-size: 8vw;

    }

}
</style>
